import React from "react";
import { format, parse } from "date-fns";

export const HistoryOrderCard = ({ order, navigate }) => {
  return (
    <div
      className="card cursor-pointer"
      onClick={() =>
        navigate(
          `/${
            order.order_status == "cancelled"
              ? "order-canceled"
              : "order-details"
          }?orderId=${order.id}`
        )
      }
    >
      <div className="card-body d-flex">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ flexGrow: 1 }}
        >
          <img
            src="/assets/images/laundry-shirt-icon 1.png"
            style={{ height: "72px", width: "72px" }}
            // className="d-none d-md-block"
            alt=""
          />
          <div className="ms-4" style={{ flexGrow: 1 }}>
            <h5 className="d-flex align-items-center justify-content-between mb-2">
              <span className="fw-semibold w-100 d-block">{order.id}</span>
              <span className="text-primary fw-semibold w-100 text-end d-block">
                Rs. {order.order_amount?.toLocaleString()}
              </span>
            </h5>
            <div className="d-flex align-items-center flex-wrap">
              <div className="col-6 pe-2">
                <h6
                  style={{ marginBottom: "3px" }}
                  className=" fw-bold hide-extra-text"
                >
                  Pickup
                </h6>
                <h6 className="mb-0 fw-bold hide-extra-text">
                  {order.pickup_time}
                </h6>
                <span className="fw-semibold text-muted hide-extra-text">
                  {format(
                    parse(order.pickup_date, "yyyy-MM-dd", Date.now()),
                    "iii, dd MMM"
                  )}
                </span>
              </div>
              {/* <div className="d-flex align-items-center col-md-auto mx-3 d-none">
                <div
                  className="fa-solid fa-circle-dot text-primary"
                  style={{ fontSize: "12px" }}
                ></div>
                <hr
                  style={{ width: "30px", borderStyle: "dashed" }}
                  className="mx-1"
                />
                <div
                  className="fa-solid fa-circle text-primary"
                  style={{ fontSize: "12px" }}
                ></div>
              </div> */}
              <div className="col-6 ps-2">
                <h6
                  style={{ marginBottom: "3px" }}
                  className=" fw-bold hide-extra-text"
                >
                  Delivery
                </h6>
                <h6 className="mb-0 fw-semibold hide-extra-text">
                  {order.order_delivery_time}
                </h6>
                <span className="fw-semibold text-muted hide-extra-text">
                  {format(
                    parse(order.delivery_date, "yyyy-MM-dd", Date.now()),
                    "iii, dd MMM"
                  )}
                </span>
              </div>
            </div>
            <hr style={{ borderStyle: "dashed", marginBottom: "10px" }} />
            <div className="d-flex justify-content-between align-items-center">
              <small className="fw-semibold d-flex align-items-center">
                <i
                  className="fa-solid fa-circle me-1"
                  style={{ fontSize: "9px", color: "#4eaf4c" }}
                ></i>
                {order.laundry_delivery_type?.title}
              </small>
              <small
                className={`history-order-card-delivery-type-badge ${
                  order?.payment_method === "card_on_delivery" ? "blue" : ""
                }`}
              >
                {order?.payment_method === "cash_on_delivery"
                  ? "cod"
                  : order?.payment_method === "card_on_delivery"
                  ? "ccod"
                  : "Digital"}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
